import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StateProviderService {
  private stateParamMap: Map<string, any> = new Map<string, any>();

  public getParam(path: string): any {
    return this.stateParamMap.get(path);
  }

  public putParam(path: string, param: any): void {
    this.stateParamMap.set(path, param);
  }

  public clearParam(path: string): void {
    this.stateParamMap.delete(path);
  }
}
